/**
 * Component: Slider
 *
 * Dependencies:
 * - OwlCarousel 2.x.x
 */

var NCSK = NCSK || {};

 NCSK.slider = NCSK.slider || function() {

    this.initImageSlider = function(selector) {
        var $selector = $(selector);

        $selector.owlCarousel({
            loop: true,
            nav: true,
            autoplay: 800,
            animateOut: 'fadeOut',
            items: 1,
            navText: ['<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/dist/icons/icons.svg#icon-arrow"></use></svg>', '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/dist/icons/icons.svg#icon-arrow"></use></svg>'],
            responsive:{
                0:{
                    nav: false
                },
                480:{
                    nav: false
                },
                768:{
                    nav: false
                },
                900:{
                    items: 1
                }
            },


        });
    }

    // Public functions
    return {
        initImageSlider: initImageSlider
    };
}();
